/* import __COLOCATED_TEMPLATE__ from './topic-tracking.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();